import React from 'react';
import { SafeAreaView, View, Text, StyleSheet, Modal, KeyboardAvoidingView, Platform } from 'react-native';
import Colors from '../../constants/Colors';
import CS from '../../constants/Styles';
import { TextInputContainer, Button } from '../../components';
import { BlurView } from 'expo-blur';
import { Portal } from 'react-native-paper';

const DeclineChangeModal = (props) => {
  const action = props.action === 'decline' ? 'declining' : 'changing';

  const confirm = () => {
    props.confirm(props.action);
  }

  const cancel = () => {
    props.setReason('');
    props.setModalVisible(false);
  }

  if(Platform.OS === 'web' && ! props.modalVisible){ return null; }
  return (
    <Portal>
      <Modal
        animationType="slide"
        transparent={true}
        visible={props.modalVisible}
        style={Platform.OS === 'web' && CS.webModal}
        >
        <BlurView intensity={85} style={StyleSheet.absoluteFill} tint='dark'>
          <KeyboardAvoidingView
            behavior={Platform.OS == "ios" ? "padding" : "height"}
            style={{ flex: 1 }}
          >
            <SafeAreaView style={styles.centeredView}>
              <View style={styles.modalView}>
                <Text style={[CS.smallText, CS.lightText, { marginBottom: 20 }]}>Provide a reason for {action} this project.</Text>
                <TextInputContainer
                  // placeholder='Cost including all fees and taxes'
                  placeholder=''
                  onChangeText={(t) => props.setReason(t)}
                  value={props.reason}
                  inputContainerStyle={{ width: '100%' }}
                  inputStyle={{ height: 100 }}
                  multiline={true}
                />
                <View style={CS.rowContainer}>
                  <View style={CS.buttonLeft}>
                    <Button text='Confirm' onPress={() => confirm} disabled={!props.reason} />
                  </View>
                  <View style={CS.buttonRight}>
                    <Button text={'Cancel'} onPress={() => cancel} color='blue' />
                  </View>
                </View>
              </View>
            </SafeAreaView>
          </KeyboardAvoidingView>
        </BlurView>
      </Modal>
    </Portal>
  )
}

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalView: {
    margin: 20,
    backgroundColor: Colors.blue,
    borderRadius: 10,
    padding: 20,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
});

export default DeclineChangeModal;